import { useState, useRef, useEffect } from "react";
import WoodButton from "./WoodButton";
import Container from "./Container";
import MintProgress from "./MintProgress";
import LoadingModal from "./LoadingModal";
import OutcomeModal from "./OutcomeModal";
import EthereumInteraction from "./EthereumInteraction";
import { parseMint } from "../utils/woolf";
// eslint-disable-next-line
import { approve } from "../utils/erc20";
// import { mint, parseMint, tokenURI, isInvalidWoolf } from '../utils/woolf'
import { watchTransaction } from "../utils/ethereum";
// import { decodeTokenURI, isSheep } from '../utils/uri'
import { decodeTokenURI } from "../utils/uri";
// import MintNStakeModal from './MintNStakeModal'
import { getInitialWhitelistStatus } from "../utils/whitelist";
import { utils, BigNumber } from "ethers";
import classes from "../design/Minting.module.scss";
import { getMinted, getTokenCount, mint } from "../utils/mintParty";

const MINT_PAUSED = "true";

// todo: change these prices in woolf.js as well
const PLACEHOLDER =
    "data:application/json;base64,eyJuYW1lIjogIldvbGYgIzI5IiwgImRlc2NyaXB0aW9uIjogIlRob3VzYW5kcyBvZiBTaGVlcCBhbmQgV29sdmVzIGNvbXBldGUgb24gYSBmYXJtIGluIHRoZSBtZXRhdmVyc2UuIEEgdGVtcHRpbmcgcHJpemUgb2YgJFdPT0wgYXdhaXRzLCB3aXRoIGRlYWRseSBoaWdoIHN0YWtlcy4gQWxsIHRoZSBtZXRhZGF0YSBhbmQgaW1hZ2VzIGFyZSBnZW5lcmF0ZWQgYW5kIHN0b3JlZCAxMDAlIG9uLWNoYWluLiBObyBJUEZTLiBOTyBBUEkuIEp1c3QgdGhlIEF2YWxhbmNoZSBibG9ja2NoYWluLiIsICJpbWFnZSI6ICJkYXRhOmltYWdlL3N2Zyt4bWw7YmFzZTY0LFBEOTRiV3dnZG1WeWMybHZiajBpTVM0d0lpQmxibU52WkdsdVp6MGlhWE52TFRnNE5Ua3RNU0kvUGcwS1BDRXRMU0JIWlc1bGNtRjBiM0k2SUVGa2IySmxJRWxzYkhWemRISmhkRzl5SURFNExqRXVNU3dnVTFaSElFVjRjRzl5ZENCUWJIVm5MVWx1SUM0Z1UxWkhJRlpsY25OcGIyNDZJRFl1TURBZ1FuVnBiR1FnTUNrZ0lDMHRQZzBLUEhOMlp5QjJaWEp6YVc5dVBTSXhMakVpSUdsa1BTSkRZWEJoWHpFaUlIaHRiRzV6UFNKb2RIUndPaTh2ZDNkM0xuY3pMbTl5Wnk4eU1EQXdMM04yWnlJZ2VHMXNibk02ZUd4cGJtczlJbWgwZEhBNkx5OTNkM2N1ZHpNdWIzSm5MekU1T1RrdmVHeHBibXNpSUhnOUlqQndlQ0lnZVQwaU1IQjRJZzBLQ1NCMmFXVjNRbTk0UFNJd0lEQWdNeklnTXpJaUlITjBlV3hsUFNKbGJtRmliR1V0WW1GamEyZHliM1Z1WkRwdVpYY2dNQ0F3SURNeUlETXlPeUlnZUcxc09uTndZV05sUFNKd2NtVnpaWEoyWlNJK0RRbzhaejROQ2drOFp5QnBaRDBpY1hWbGMzUnBiMjVmZURWR1gyMWhjbXNpUGcwS0NRazhaejROQ2drSkNUeHdZWFJvSUhOMGVXeGxQU0ptYVd4c09pTXdNekF4TURRN0lpQmtQU0pOTVRjdU5pd3pNR013TERFdU1UQXlMVEF1T0RrMUxESXRNaXd5Y3kweUxUQXVPRGs0TFRJdE1tTXdMVEV1TVRBNUxEQXVPRGsxTFRJc01pMHlVekUzTGpZc01qZ3VPRGt4TERFM0xqWXNNekI2SWk4K0RRb0pDUWs4Y0dGMGFDQnpkSGxzWlQwaVptbHNiRG9qTURNd01UQTBPeUlnWkQwaVRURTFMalkzTml3eU5TNDVOemRqTFRFdU16TTJMREF0TWk0MU9TMHdMalV5TXkwekxqVXpOUzB4TGpRMk9XTXRNQzQ1TkRVdE1TNHhNRFV0TVM0ME5qVXRNaTR6TlRrdE1TNDBOalV0TXk0Mk9UVU5DZ2tKQ1Fsek1DNDFNaTB5TGpVNUxERXVORFkxTFRNdU16Y3hiRFl1TmpnNExUWXVOamc0UXpFNUxqVTROQ3c1TGprNU5pd3lNQ3c0TGprNU1pd3lNQ3czTGpreU5tTXdMVEV1TURjdE1DNDBNVFl0TWk0d056UXRNUzR4TnpJdE1pNDRNamdOQ2drSkNRbGpMVEV1TlRVNUxURXVOVFU1TFRRdU1EazJMVEV1TlRZeUxUVXVOalUwTERCRE1USXVOREUyTERVdU9EVXlMREV5TERZdU9EVTFMREV5TERjdU9USTJTRGhqTUMweUxqRXpOeXd3TGpnek5DMDBMakUwT0N3eUxqTTBPQzAxTGpZMkRRb0pDUWtKWXpNdU1ESXRNeTR3TWpNc09DNHlPRFV0TXk0d01pd3hNUzR6TURrc01DNHdNRFJETWpNdU1UWTRMRE11TnpjM0xESTBMRFV1TnpnMUxESTBMRGN1T1RJMll6QXNNaTR4TXpjdE1DNDRNeklzTkM0eE5EVXRNaTR6TkRRc05TNDJOVFpzTFRZdU5qZzRMRFl1TlRJekRRb0pDUWtKWXkwd0xqTTRPU3d3TGpNNU1TMHdMak00T1N3eExqQXlNeXd3TERFdU5ERTBZekF1TXpreExEQXVNemt4TERFdU1ESXpMREF1TXpreExERXVOREUwTERCak1DNHlOVFF0TUM0eU5UZ3NNQzR5T1RNdE1DNDFOVFVzTUM0eU9UTXRNQzQzTVRGb05BMEtDUWtKQ1dNd0xERXVNek0yTFRBdU5USXNNaTQxT1RRdE1TNDBOalVzTXk0Mk9UbERNVGd1TWpZMkxESTFMalExTXl3eE55NHdNVElzTWpVdU9UYzNMREUxTGpZM05pd3lOUzQ1TnpkTU1UVXVOamMyTERJMUxqazNOM29pTHo0TkNna0pQQzluUGcwS0NUd3ZaejROQ2p3dlp6NE5DanhuUGcwS1BDOW5QZzBLUEdjK0RRbzhMMmMrRFFvOFp6NE5Dand2Wno0TkNqeG5QZzBLUEM5blBnMEtQR2MrRFFvOEwyYytEUW84Wno0TkNqd3ZaejROQ2p4blBnMEtQQzluUGcwS1BHYytEUW84TDJjK0RRbzhaejROQ2p3dlp6NE5DanhuUGcwS1BDOW5QZzBLUEdjK0RRbzhMMmMrRFFvOFp6NE5Dand2Wno0TkNqeG5QZzBLUEM5blBnMEtQR2MrRFFvOEwyYytEUW84Wno0TkNqd3ZaejROQ2p3dmMzWm5QZzBLIiwgImF0dHJpYnV0ZXMiOlt7InRyYWl0X3R5cGUiOiJGdXIiLCJ2YWx1ZSI6IkdyYXkifSx7InRyYWl0X3R5cGUiOiJIZWFkIiwidmFsdWUiOiJCZXRhIn0seyJ0cmFpdF90eXBlIjoiRXllcyIsInZhbHVlIjoiQ2xvc2VkIn0seyJ0cmFpdF90eXBlIjoiTW91dGgiLCJ2YWx1ZSI6IlNtaXJrIn0seyJ0cmFpdF90eXBlIjoiTmVjayIsInZhbHVlIjoiVGllIn0seyJ0cmFpdF90eXBlIjoiQWxwaGEgU2NvcmUiLCJ2YWx1ZSI6IjcifSx7InRyYWl0X3R5cGUiOiJHZW5lcmF0aW9uIiwidmFsdWUiOiJHZW4gMCJ9LHsidHJhaXRfdHlwZSI6IlR5cGUiLCJ2YWx1ZSI6IldvbGYifV19";
// TODO: update mint price
const MINT_PRICE = "75";
const PAY_WITH = {
    MATIC: "MATIC"
};

// eslint-disable-next-line
const paymentOptions = [
    { id: PAY_WITH.MATIC, title: "MATIC" }
];

const Minting = ({ wallet, chain, stats, reload, woolBalance, walletMintedCount }) => {
    const [amount, setAmount] = useState(1);
    const [loading, setLoading] = useState(false);
    const [transacting, setTransacting] = useState(false);
    const [error, setError] = useState(null);
    const outcomesTestSrc = "data:image/svg+xml;base64,PHN2ZyBpZD0id29vbGYiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDQwIDQwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48aW1hZ2UgeD0iNCIgeT0iNCIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBpbWFnZS1yZW5kZXJpbmc9InBpeGVsYXRlZCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiIHhsaW5rOmhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBQ0FBQUFBZ0JBTUFBQUNCVkdmSEFBQUFGVkJNVkVVQUFBRGZ2cWV5alhPVVhGa0FBQUIzUmt3bkp5ZTVySXhFQUFBQUFYUlNUbE1BUU9iWVpnQUFBT2xKUkVGVUtNOWQwVXR5d3lBTUJ1QXN1QUR1WTU5Zk5BZVFTTmNFSzltM3VBZm9lSHovSzBRbWptR2loWmo1UmhJYU9GaG9hcmxHRHBZY0dveElwdFFCQjFWSUJ3S0FPc2pldy9zT0xoWGFET2NyRExHREFZYmhGZDUzT0c3UURhM1JYN3ZHME1CVitIeUZPYlNXLzdXQTI2cmpsOEV2eS9Uc0VQejREd0xGSFhqd0VKSnoyb0RZVm1NaTJZR08vZzBtMHhQQUhzUzhEOG5NQTR0SlRCdWNyWitwVUpnZU1uNkRCVklrY256QUtZT0VaZzRGcWJhY1JxRHdJa0U1MUlvNEFiTmNTOXcrY1lrVDQxWnV5d1pYaVg5akxHS244eXRranFwS2xEbGQ2anM2VmN1cVRpMGQ3cUt1TTY2TGlsVnpBQUFBQUVsRlRrU3VRbUNDIi8+PGltYWdlIHg9IjQiIHk9IjQiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgaW1hZ2UtcmVuZGVyaW5nPSJwaXhlbGF0ZWQiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIiB4bGluazpocmVmPSJkYXRhOmltYWdlL3BuZztiYXNlNjQsaVZCT1J3MEtHZ29BQUFBTlNVaEVVZ0FBQUNBQUFBQWdCQU1BQUFDQlZHZkhBQUFBRWxCTVZFVUFBQURwNGlXeEhSamVzQy9hUERhR0lpZXkwK2I5QUFBQUFYUlNUbE1BUU9iWVpnQUFBRFZKUkVGVUtNOWpBQUZtQVVNQlF3WWtJT1NvNUtnaWdPQXpCNGtxcVFnNUlxa3dWUXhTREFLcVFDZ3hOaFlVWkJnRnd3d0FBQ2EyQkNuUmtpb3JBQUFBQUVsRlRrU3VRbUNDIi8+PGltYWdlIHg9IjQiIHk9IjQiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgaW1hZ2UtcmVuZGVyaW5nPSJwaXhlbGF0ZWQiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIiB4bGluazpocmVmPSJkYXRhOmltYWdlL3BuZztiYXNlNjQsaVZCT1J3MEtHZ29BQUFBTlNVaEVVZ0FBQUNBQUFBQWdCQU1BQUFDQlZHZkhBQUFBRlZCTVZFVUFBQUJEUDJSUVdaWXdZOVBhUERZa1VwbXhIUmdrdllKSkFBQUFBWFJTVGxNQVFPYllaZ0FBQUNwSlJFRlVLTTlqb0JzUVVoSVVGRlJTRW9RTE1JWUdNcVlsTWpBSXdBV01EUmxkSExFS2pJSUJBZ0N6RVFReUxKZzRVZ0FBQUFCSlJVNUVya0pnZ2c9PSIvPjxpbWFnZSB4PSI0IiB5PSI0IiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGltYWdlLXJlbmRlcmluZz0icGl4ZWxhdGVkIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCIgeGxpbms6aHJlZj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LGlWQk9SdzBLR2dvQUFBQU5TVWhFVWdBQUFDQUFBQUFnQWdNQUFBQU9GSkpuQUFBQURGQk1WRVVBQUFBQUFBQ0dSRXVtWEZpeUxRdXFBQUFBQVhSU1RsTUFRT2JZWmdBQUFCdEpSRUZVR05Oam9Bdmcvd0JsY0MyQU1vUWFvUXpXRUliQkRBREZXUUtXZTFvMGFRQUFBQUJKUlU1RXJrSmdnZz09Ii8+PGltYWdlIHg9IjQiIHk9IjQiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgaW1hZ2UtcmVuZGVyaW5nPSJwaXhlbGF0ZWQiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIiB4bGluazpocmVmPSJkYXRhOmltYWdlL3BuZztiYXNlNjQsaVZCT1J3MEtHZ29BQUFBTlNVaEVVZ0FBQUFFQUFBQUJDQVFBQUFDMUhBd0NBQUFBQzBsRVFWUjQybU5rWUFBQUFBWUFBakNCMEM4QUFBQUFTVVZPUks1Q1lJST0iLz48L3N2Zz4=";
    const [outcomes, setOutcomes] = useState(
        []
        /*  [
             {
                 message: `You arrived safely at home with SHeep #0xe4e68f43704263caf50808714da38b079809d49a`,
                 source: outcomesTestSrc,
                 link: `${process.env.REACT_APP_OPENSEA}/${process.env.REACT_APP_WOOLF}/0xe4e68f43704263caf50808714da38b079809d49a`,
                 linkMessage: 'View on OpenSea'
             },
             {
                 message: `You arrived safely at home with Wolf #0xe4e68f43704263caf50808714da38b079809d49a`,
                 source: outcomesTestSrc,
                 link: `${process.env.REACT_APP_OPENSEA}/${process.env.REACT_APP_WOOLF}/0xe4e68f43704263caf50808714da38b079809d49a`,
                 linkMessage: 'View on OpenSea'
             },
             {
                 message: `You arrived safely at home with Wolf #0xe4e68f43704263caf50808714da38b079809d49a`,
                 source: outcomesTestSrc,
                 link: `${process.env.REACT_APP_OPENSEA}/${process.env.REACT_APP_WOOLF}/0xe4e68f43704263caf50808714da38b079809d49a`,
                 linkMessage: 'View on OpenSea'
             },
         ] */
    );
    // const [mintingAndStaking, setMintingAndStaking] = useState(false)
    const [, setMintingAndStaking] = useState(false);
    const [paymentToken, setPaymentToken] = useState(PAY_WITH.MATIC);
    const [partyMinted, setPartyMinted] = useState();
    const [partyTokens, setPartyTokens] = useState();
    const [intervalMinting, setIntervalMinting] = useState();

    useEffect(() => {
        if (wallet) {
            if (intervalMinting !== undefined) clearInterval(intervalMinting);

            const interval = setInterval(async () => {
                setPartyMinted(await getMinted());
                setPartyTokens(await getTokenCount());
            }, 2500);

            setIntervalMinting(interval);

            return () => clearInterval(interval);
        }
    }, [wallet])

    // for OG discount
    const [isOG, setIsOG] = useState(false);

    // eslint-disable-next-line
    const onPaymentToken = (e) => {
        setPaymentToken(e.target.id);
    };

    const onMint = async () => {
        if (paymentToken === PAY_WITH.MATIC) {
            setLoading(true);
            setError(null);
            try {
                // added OG boolean
                const result = await mint(amount, requiresEth());
                if (typeof result === "object" && !("hash" in result)) {
                    setLoading(false);
                    setTransacting(false);
                    if (result?.data?.code === -32000) return setError("Mint failed. Insufficient funds.");
                    else return setError("Mint failed.");
                }
                let hash = result.hash;

                setTransacting(true);
                setMintingAndStaking(false);

                watchTransaction(hash, (receipt, success) => {
                    if (!success) {
                        setLoading(false);
                        setTransacting(false);
                        return setError("Mint failed. Check transaction.");
                    }

                    const results = parseMint(receipt);

                    setTimeout(async () => {
                        await presentOutcomes(results);
                        setLoading(false);
                        setTransacting(false);
                    }, 2000);
                });
            } catch (e) {
                //console.log(e);
                setLoading(false);
            }
        }
    };

    // const delay = (time) => {
    //   return new Promise(res => setTimeout(res, time))
    // }

    // const getWoolf = async (tokenId) => {
    //   try {
    //     let u = await tokenURI(tokenId)
    //     while (isInvalidWoolf(decodeTokenURI(u))) {
    //       console.log('RETRYING')
    //       await delay(1000)
    //       u = await tokenURI(tokenId)
    //     }
    //     return u
    //   } catch (e) {
    //     console.log('READ FAILED. RETRYING')
    //     return getWoolf(tokenId)
    //   }
    // }

    const presentOutcomes = async (results) => {
        const o = [];
        for (let i in results) {
            // const { tokenId, recipient, stake } = results[i]
            const { tokenId, recipient } = results[i];

            // let u = await getWoolf(tokenId)
            let u = PLACEHOLDER;

            const stolen = recipient.toLowerCase() !== wallet.toLowerCase();

            if (stolen) {
                const shortRecipient = `${recipient.slice(0, 6)}...${recipient.slice(-4)}`;
                o.push(
                    {
                        message: `You minted a sheep or a woolf #${tokenId.toString()} BUT...`,
                        source: decodeTokenURI(u).image,
                        link: "",
                        linkMessage: "",
                    },
                    {
                        message: `It was stolen by a Wolf! It's now owned by ${shortRecipient}`,
                        source: "/images/mint-stolen.gif",
                    }
                );
            } else {
                // * og
                // o.push({
                //   message:`You arrived safely at home with ${isSheep(u) ? 'Sheep' : 'Wolf'} #${tokenId.toString()}...`,
                //   source: decodeTokenURI(u).image,
                //   link:`${process.env.REACT_APP_OPENSEA}/${process.env.REACT_APP_WOOLF}/${tokenId.toString()}`,
                //   linkMessage:'View on OpenSea'
                // })
                o.push({
                    message: `You arrived safely at home with a sheep or a woolf #${tokenId.toString()}...`,
                    source: decodeTokenURI(u).image,
                    link: "",
                    linkMessage: "",
                });
            }
        }
        setOutcomes(o);
    };

    const totalMinted = () => {
        if (!stats) return 0;
        // return parseInt(stats.sheepMinted) + parseInt(stats.wolvesMinted)
        return parseInt(stats.totalSupply) - partyTokens + partyMinted;
    };

    const maxTokens = () => {
        if (!stats) return 50000;
        return stats.maxTokens;
    };

    const requiresEth = () => {
        if (!stats) return true;
        return totalMinted() < parseInt(stats.maxTokens) / 5;
    };

    // added OG logic
    const ethCost = () => {
        if (process.env.REACT_APP_IS_PRESALE === "true" && isOG && amount > 2) {
            const adjustedDiscount = amount - 1;
            return utils.formatUnits(utils.parseUnits(MINT_PRICE, "gwei").mul(BigNumber.from(adjustedDiscount)), "gwei") + " MATIC (OG's 1 FREE NFT DISCOUNT APPLIED)";
        }

        return utils.formatUnits(utils.parseUnits(MINT_PRICE, "gwei").mul(BigNumber.from(amount)), "gwei") + " MATIC";
    };

    const woolCost = (tokenId) => {
        if (!stats) return 0;
        let maxTokens = parseInt(stats.maxTokens);
        if (tokenId <= (maxTokens * 2) / 5) return 20000;
        if (tokenId <= (maxTokens * 3) / 5) return 30000;
        if (tokenId <= (maxTokens * 4) / 5) return 40000;
        return 50000;
    };

    const totalWoolCost = () => {
        if (!stats) return 0;
        let total = 0;
        let currentId = totalMinted();
        for (let i = 1; i <= amount; i++) {
            total += woolCost(currentId + i);
        }
        return total;
    };

    const preCheck = () => {
        if (MINT_PAUSED === "true") return "All NFTs Minted";
        if (process.env.REACT_APP_IS_PRESALE === "true") {
            const initialWhitelistStatus = getInitialWhitelistStatus(wallet);
            if (initialWhitelistStatus !== 2) {
                if (isOG) setIsOG(false);
            }
            if (initialWhitelistStatus === 0) return "You are not on the whitelist. Please continue to mint in the public sale at 4pm PST.";
            if (parseInt(walletMintedCount) > 0) return "You have already minted during the presale. Please continue to mint in the public sale at 4pm PST.";
            // if they are a valid OG, we set the boolean so OGs get a discount
            if (initialWhitelistStatus === 2) setIsOG(true);
        }
        if (process.env.NODE_ENV === "development") return false;
        if (requiresEth()) return undefined;
        if (!woolBalance || woolBalance === "?") return "Insufficient $FFWOOL";
        if (utils.parseUnits("" + totalWoolCost(), "gwei").gt(woolBalance)) return "Insufficient $FFWOOL";
        return undefined;
    };

    return (
        <Container>
            <div className={`flex flex-col items-center font-pixel ${wallet ? "gap-5" : ""}`}>
                <div className="text-2xl sm:text-4xl font-bold mt-5 uppercase">Minting</div>
                <MintProgress minted={maxTokens()} maxTokens={maxTokens()} />
                <div className="mt-2"></div>

                {totalMinted() >= maxTokens() ? (
                    <div className="text-red text-xl sm:text-2xl text-center">Sold out!</div>
                ) : (
                    <EthereumInteraction wallet={wallet} chain={chain}>
                        {MINT_PAUSED === "false" &&
                            <div className={classes.mint}>
                                <div className="flex justify-center items-center gap-2" style={{ height: "50px" }}>
                                    <div className="pt-2 mr-3">Amount:</div>
                                    <img
                                        src="/images/arrow-down.svg"
                                        alt="decrease"
                                        className="cursor-pointer"
                                        style={{ minWidth: "25px" }}
                                        onClick={() => {
                                            if (process.env.REACT_APP_IS_PRESALE === "true" && isOG && amount === 3) {
                                                setAmount(Math.max(1, amount - 1 - 1));
                                            } else {
                                                setAmount(Math.max(1, amount - 1));
                                            }
                                        }}
                                    />
                                    <div className="font-console text-red text-xl sm:text-3xl pt-2"><span className={classes.amount}>{amount}</span></div>
                                    <img
                                        src="/images/arrow-up.svg"
                                        alt="decrease"
                                        className="cursor-pointer"
                                        style={{ minWidth: "25px" }}
                                        onClick={() => {
                                            if (process.env.REACT_APP_IS_PRESALE === "true" && isOG && amount === 1) {
                                                setAmount(Math.min(10, amount + 1 + 1));
                                            } else {
                                                setAmount(Math.min(10, amount + 1));
                                            }
                                        }}
                                    />
                                </div>
                                <div className="mb-5">
                                    Cost:
                                    {" "}
                                    <span className={classes.cost}>
                                        <span className={classes.value}>
                                            {requiresEth() ? ethCost() : `${totalWoolCost()} "$FFWOOL`}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        }

                        {preCheck() ? (
                            <div className="text-red text-xl sm:text-2xl">{preCheck()}</div>
                        ) : (
                            <div className="flex xl:flex-row flex-col justify-center items-center gap-5">
                                <div className="flex flex-col justify-center items-center">
                                    <WoodButton
                                        title={"MINT"}
                                        loading={loading}
                                        onClick={onMint}
                                    />
                                    {/* <span className="mt-4">WITH</span>
                  <fieldset className="mt-4">
                    <legend className="sr-only">Notification method</legend>
                    <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                      {paymentOptions.map((paymentOption) => (
                        <div
                          key={paymentOption.id}
                          className="flex items-center"
                        >
                          <input
                            id={paymentOption.id}
                            name="notification-method"
                            type="radio"
                            defaultChecked={paymentOption.id === PAY_WITH.MATIC}
                            className="focus:ring-black h-4 w-4 text-black border-black"
                            onClick={onPaymentToken}
                          />
                          <label
                            htmlFor={paymentOption.id}
                            className="ml-3 block text-sm font-medium text-black"
                          >
                            {paymentOption.title}
                          </label>
                        </div>
                      ))}
                    </div>
                  </fieldset> */}
                                    <div className="mt-2" style={{ height: "20px" }}></div>
                                </div>
                                {/* <div className="flex flex-col justify-center items-center">
                  <WoodButton width={250} height={40} title={'MINT & STAKE'} fontSize={20} loading={loading} onClick={() => {
                    setMintingAndStaking(true)
                  }}/>
                  <div className="font-console text-xs mt-2 text-center" style={{height:'20px'}}>
                    (saves gas)
                  </div>
                </div> */}
                            </div>
                        )}

                        {error && <div className="text-xl text-red font-console text-center">{error}</div>}
                    </EthereumInteraction>
                )}
            </div>
            <LoadingModal
                loadingScenes={[
                    {
                        message: "Bringing a baby sheep (or wolf?) back home",
                        source: "/images/minting.gif",
                    },
                ]}
                modalIsOpen={!!transacting}
            />
            <OutcomeModal
                outcomes={outcomes}
                modalIsOpen={outcomes.length > 0}
                closeModal={() => {
                    setOutcomes([]);
                    reload();
                }}
            />
        </Container>
    );
};

export default Minting;